import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Tag, Text } from '@beef/ui-kit';

import { Image } from '../../Image';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const PageRowTitle = ({ icon, svgIcon, title, isActive, className }) => (
  <div className={className}>
    <Text size="size2-m" tagType="h2">
      <div className={cn('component')}>
        {icon && <Image className={cn('icon')} src={icon} />}
        {svgIcon && <div className={cn('icon')}>{svgIcon()}</div>}
        {title}
        {isActive && (
          <Tag data-testid="app-page-row-title-tag" textColor="white" variant="green50">
            активен
          </Tag>
        )}
      </div>
    </Text>
  </div>
);

PageRowTitle.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.string,
  svgIcon: PropTypes.func,
  isActive: PropTypes.bool,
};
